import { ApplicationState } from '../reducers';
import { ICVCState, PolicyAccommodationAddressType } from 'ts/types/icvc.types';

export const icvcSelector = (state: ApplicationState): ICVCState => state.icvc;

export const iCVCErrorSelector = (state: ApplicationState): any =>
  icvcSelector(state).error;

export const icvcDataReviewedSelector = (state: ApplicationState): boolean =>
  icvcSelector(state).reviewed;

export const accommodationAddressSelector = (
  state: ApplicationState,
): PolicyAccommodationAddressType => icvcSelector(state).accommodation_address!;

export const iCVCPolicyInformationSelector = (state: ApplicationState): any =>
  icvcSelector(state)?.policy_information;

export const iCVCPolicyIdSelector = (state: ApplicationState): any =>
  icvcSelector(state)?.policy_id;

export const iCVCEligibilityTokenSelector = (state: ApplicationState): any =>
  icvcSelector(state)?.eligibility_token;

export const iCVCShowModalSelector = (state: ApplicationState): any =>
  icvcSelector(state).showModal;

export const iCVCPackageSelector = (state: ApplicationState): any =>
  iCVCPolicyInformationSelector(state)?.package;

export const iCVCEffectivePeriodSelector = (state: ApplicationState): any =>
  iCVCPolicyInformationSelector(state)?.effective_period;

export const iCVCProductIdSelector = (state: ApplicationState): any =>
  iCVCPackageSelector(state)?.product_id;

export const iCVCOptionsSelector = (state: ApplicationState): any =>
  iCVCPackageSelector(state)?.options;
